export enum HandoverStatus {
    // has this role currently
    HandoverInProgress = "HandoverInProgress",
    HandoverLater = "HandoverLater",

    // will have this role in the future
    TransitionToRoleLater = "TransitionToRoleLater",
    TransitionToRoleInProgress = "TransitionToRoleInProgress",
}

export class HandoverStatusMetadata {
    public static readonly None = new HandoverStatusMetadata(undefined, "None", "fal fa-fw");
    public static readonly HandoverInProgress = new HandoverStatusMetadata(HandoverStatus.HandoverInProgress, "Handing role over now", "fal fa-fw fa-circle-minus");
    public static readonly HandoverLater = new HandoverStatusMetadata(HandoverStatus.HandoverLater, "Handing role over later", "fal fa-fw fa-clock");
    public static readonly TransitionToRoleLater = new HandoverStatusMetadata(HandoverStatus.TransitionToRoleLater, "Transitioning to role later", "fal fa-fw fa-flip-horizontal fa-person-walking-dashed-line-arrow-right");
    public static readonly TransitionToRoleInProgress = new HandoverStatusMetadata(HandoverStatus.TransitionToRoleInProgress, "Transitioning to role", "fal fa-fw fa-circle-plus");

    public static readonly CurrentRoleHandoverOptions = [
        HandoverStatusMetadata.None,
        HandoverStatusMetadata.HandoverInProgress,
        HandoverStatusMetadata.HandoverLater,
        HandoverStatusMetadata.TransitionToRoleInProgress,
    ];

    public static readonly ByStatus: { [status in HandoverStatus]: HandoverStatusMetadata } = {
        [HandoverStatus.HandoverInProgress]: HandoverStatusMetadata.HandoverInProgress,
        [HandoverStatus.HandoverLater]: HandoverStatusMetadata.HandoverLater,
        [HandoverStatus.TransitionToRoleLater]: HandoverStatusMetadata.TransitionToRoleLater,
        [HandoverStatus.TransitionToRoleInProgress]: HandoverStatusMetadata.TransitionToRoleInProgress,
    };

    private constructor(
        public readonly status: HandoverStatus | undefined,
        public readonly name: string,
        public readonly icon: string,
    ) { }
}
